import script from "./sockets.vue?vue&type=script&lang=js"
export * from "./sockets.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__